export const PRINT_STORE_ANALYTICS_ENTRY = 'analytics_page_print_store_entry'
export const FLOWLYTICS_TOGGLE_ORG_DATA = 'flowlytics_toggle_org_data'
export const FLOWLYTICS_SCHEDULED_ANALYTICS = 'flowlytics_scheduled_analytics'
export const FLOWLYTICS_PIXEL_WIZARD = 'flowlytics_pixel_wizard'
export const FLOWPAGE_PIXEL_PASSTHROUGH = 'flowpage_pixel_passthrough'
export const FLOWLYTICS_CONVERSIONS_PAGE = 'flowlytics_conversion_reports_page'
export const FLOWLYTICS_RAW_EVENTS = 'flowlytics_raw_events'
export const FLOWLYTICS_CONVERSIONS_BETA_BANNER = 'flowlytics_conversions_beta_banner'
export const FLOWLYTICS_PIXEL_MANAGEMENT_V2 = 'flowlytics_pixel_management_v2'
export const FLOWLYTICS_COMPETITIVE_BENCHMARKING = 'flowlytics_competitive_benchmarking'
export const FLOWLYTICS_DATA_CAPS = 'flowlytics_data_caps'
export const DESKTOP_LOCG_EMAIL_PASSWORD_FIELDS_ABOVE_THE_FOLD =
  'desktop_locg_email_password_fields_above_the_fold'
export const DESKTOP_LOCG_DESIGN_ABOVE_FOLD = 'desktop_locg_design_above_fold'
